import React from "react"
import Styled from "styled-components"
import "./wave.css"

const Wave = ({ children }) => {
  return (
    <section>
      {children}
      <div className="wave wave1"></div>
      <div className="wave wave2"></div>
      <div className="wave wave3"></div>
      <div className="wave wave4"></div>
    </section>
  )
}
export default Wave
